export default "__VITE_ASSET__ZsHY9E8g__"